'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /* eslint-disable */

// Components

// Redux actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('../../components');

var _booking = require('../../redux/modules/booking');

var _alert = require('../../redux/modules/alert');

var _action = require('../../redux/modules/action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// GraphQL
// import { gql, graphql } from 'react-apollo';

// const getStatus = gql`
//   query getStatus($id: String!) {
//     booking(id: $id) {
//       data {
//         status
//         bookingType
//       }
//       error {
//         code
//         message
//         errors
//       }
//     }
//   }
// `;
// const mapGetStatusToProps = graphql(getStatus, {
//   props: ({ data }) => ({
//     loading: data.loading,
//     booking: data.booking
//   }),
//   options: props => {
//     // console.log(props);
//     return { variables: { id: props.orderNumber } };
//   }
// });
var mapStateToProps = function mapStateToProps(state) {
  return {
    btnActive: state.booking.active,
    info: state.booking.data,
    orderNumber: state.booking.orderNumber,
    showModal: state.modal.show
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadActions: _action.load, loadBooking: _booking.load, setButtonActive: _booking.setButtonActive, setCustomStatus: _booking.setCustomStatus, setOrderNumber: _booking.setOrderNumber, showAlert: _alert.show, queryBooking: _booking.queryBooking
  }, dispatch);
};

var Automation = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Automation, _Component);

  function Automation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Automation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Automation.__proto__ || (0, _getPrototypeOf2.default)(Automation)).call.apply(_ref, [this].concat(args))), _this), _this.alert = function (module) {
      _this.props.showAlert(module);
    }, _this.checkOrderStatus = function () {
      var $props = _this.props;
      // $props.loadBooking($props.orderNumber)
      // graphQL query
      $props.queryBooking('{\n      booking(id: "' + $props.orderNumber + '") {\n        data {\n          status\n          bookingType\n        }\n        error {\n          code\n          message\n          errors\n        }\n      }\n    }').then(function (res) {
        var data = res.data.booking.data ? res.data.booking.data : null;
        var bookingType = data ? data.bookingType : null;
        var status = data ? data.status : null;
        var setStatus = function setStatus(statusText) {
          return $props.setCustomStatus(statusText);
        };
        // set custom booking status message      
        if (bookingType === 'Instant') {
          switch (status) {
            case 'Enroute Pickup':
              setStatus('Out for Pickup');
              break;
            case 'Enroute Drop':
              setStatus('Out for Delivery');
              break;
            default:
              setStatus(status);
              break;
          }
        } else {
          setStatus(status);
        }
        _this.alert('info');
        _this.loadActions();
      });
    }, _this.loadActions = function () {
      var $props = _this.props;
      // graphQL query
      return $props.loadActions('{\n      actionList(id: "' + $props.orderNumber + '") {\n        data {\n          actions {\n            action, action_name, method, path, text_input, failure_reasons {\n              id, reason\n            }\n          }\n        }\n        error {\n          code\n          message\n          errors\n        }\n      }\n    }');
    }, _this.disableSubmit = function (evt) {
      // disable default submit action for form when enter button pressed
      evt.preventDefault();
    }, _this.setButtonActive = function (evt) {
      var $props = _this.props;
      var value = evt.target.value;
      if (value.length) {
        $props.setButtonActive(true);
      } else {
        $props.setButtonActive(false);
      }
      // set order number
      $props.setOrderNumber(value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Automation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          info = _props.info,
          showModal = _props.showModal,
          btnActive = _props.btnActive,
          orderNumber = _props.orderNumber;

      var styles = require('./Automation.scss');
      var self = this;
      var reset = false;
      var resetBooking = false;
      var statusdisabled = false;

      if (info) {
        var status = info.error ? 'Not Available' : info.data.status;
        var statusVal = status ? status.replace(/\s/g, '').toLowerCase() : null;

        // status colors
        if (statusVal === 'rejected' || statusVal === 'cancelled' || statusVal === 'drivernotfound') {
          reset = true;
          resetBooking = false;
        } else if (statusVal === 'completed') {
          reset = true;
          resetBooking = false;
        } else {
          resetBooking = true;
        }

        // set allocated
        if (statusVal === 'findingdriver') {
          resetBooking = false;
          statusdisabled = false;
        } else if (statusVal === 'notavailable') {
          resetBooking = false;
          statusdisabled = false;
        } else {
          statusdisabled = true;
        }
      }

      return _react2.default.createElement(
        'section',
        { className: styles.automation },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Automation' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'form',
            { className: styles.automationForm, onSubmit: this.disableSubmit },
            _react2.default.createElement(
              _components.Input,
              { text: 'Status Booking', styles: styles },
              _react2.default.createElement(_components.Status, { styles: styles, info: info })
            ),
            _react2.default.createElement(
              _components.Input,
              { text: 'Order Number', styles: styles },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', { type: 'text', ref: 'orderNumber', 'data-type': 'orderNumber', onChange: this.setButtonActive, value: orderNumber, placeholder: 'Enter Order Number', className: 'form-control', disabled: statusdisabled }),
                _react2.default.createElement(_components.Button, { text: 'Check Status', onclick: this.checkOrderStatus, disabled: !btnActive })
              )
            ),
            _react2.default.createElement(
              _components.Input,
              { text: 'Order Type', styles: styles },
              _react2.default.createElement(_components.Allocate, { loadActions: this.loadActions, checkOrderStatus: this.checkOrderStatus, alert: this.alert })
            ),
            _react2.default.createElement(
              _components.Input,
              { text: 'Action', styles: styles },
              _react2.default.createElement(_components.ActionList, { styles: styles, info: info, loadActions: this.loadActions, checkOrderStatus: this.checkOrderStatus })
            ),
            resetBooking && _react2.default.createElement(_components.Reset, { checkAnother: resetBooking }),
            reset && _react2.default.createElement(_components.Reset, null)
          )
        ),
        showModal && _react2.default.createElement(_components.Modal, { checkOrderStatus: this.checkOrderStatus })
      );
    }
  }]);
  return Automation;
}(_react.Component), _class.propTypes = {
  // states
  btnActive: _propTypes2.default.bool,
  info: _propTypes2.default.object,
  orderNumber: _propTypes2.default.string,
  showModal: _propTypes2.default.bool,
  // actions dispatch
  loadActions: _propTypes2.default.func,
  loadBooking: _propTypes2.default.func,
  setButtonActive: _propTypes2.default.func,
  setCustomStatus: _propTypes2.default.func,
  setOrderNumber: _propTypes2.default.func,
  showAlert: _propTypes2.default.func,
  queryBooking: _propTypes2.default.func
}, _temp2);
exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)
// mapGetStatusToProps
)(Automation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Automation/Automation.js
// module id = 868
// module chunks = 0